export default __webpack_public_path__ + "static/green-school_6-075b993e29601003a49457572a01f192.png";